export function initSupportDrawer() {
    const container = document.getElementById('supportContainer') as HTMLInputElement;
    const drawer = document.getElementById('supportDrawer') as HTMLInputElement;
    const tab = document.getElementById('supportTab') as HTMLInputElement;
    
    if (!container || !drawer || !tab) {
      console.error('Support elements not found');
      return;
    }
  
    tab.addEventListener('click', () => {
      container.classList.toggle('open');
    });
  
    // Optional: Close if user clicks outside the panel
    document.addEventListener('click', (ev: Event) => {
      if (container.classList.contains('open')) {
        // Only close if outside support drawer
        if (!drawer.contains(ev.target as Node)) {
          container.classList.remove('open');
        }
      }
    });
  }